var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "../base";
var ChatTextLoader = /** @class */ (function (_super) {
    __extends(ChatTextLoader, _super);
    function ChatTextLoader(color) {
        var _this = _super.call(this) || this;
        var container = document.createElement('div');
        container.style.display = 'flex';
        var loader = document.createElement('div');
        loader.className = 'chat-bot-message-loader';
        loader.style.height = '5px';
        loader.style.marginTop = '19px';
        loader.style.marginLeft = '5px';
        loader.insertAdjacentHTML('beforeend', "\n        <style type=\"text/css\">\n        .chat-bot-message-loader {\n        width: 20px;\n        aspect-ratio: 4;\n        --_g: no-repeat radial-gradient(circle closest-side,#000 90%,#0000);\n        background: \n            var(--_g) 0%   50%,\n            var(--_g) 50%  50%,\n            var(--_g) 100% 50%;\n        background-size: calc(100%/3) 100%;\n        animation: l7 1s infinite linear;\n        }\n        @keyframes l7 {\n            33%{background-size:calc(100%/3) 0%  ,calc(100%/3) 100%,calc(100%/3) 100%}\n            50%{background-size:calc(100%/3) 100%,calc(100%/3) 0%  ,calc(100%/3) 100%}\n            66%{background-size:calc(100%/3) 100%,calc(100%/3) 100%,calc(100%/3) 0%  }\n        }\n        </style>\n        ");
        var textElement = document.createElement('div');
        textElement.innerHTML = "".concat(process.env.AIGO_CHAT_ASSISTANT_LOADING_MESSAGE);
        container.appendChild(textElement);
        container.appendChild(loader);
        _this.self = container;
        return _this;
    }
    return ChatTextLoader;
}(Base));
export { ChatTextLoader };
